module.exports = __webpack_public_path__ + "assets/star-half-d4f96c.svg";